<div class="modal active" *ngIf="model != undefined">
    <div class="modal__container" style="width: 50%; height: 50%; top: 10%;">
      <div class="fields">
        <h2>Processing Tool Export Menu</h2>
        <div class="close" (click)="cancelExport()"><img src="/assets/img/close-white.svg" alt="" /></div>
        <div class="fields__container">
          <form autocomplete="off"  name="ngImportCsvForm" #ngForm="ngForm" id="importCsvForm" class="active">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>Configured Fields</h4>
                  <span> </span>
                </div>
                <div class="table-fields">
                  <div style="max-height: 242px; overflow-y: auto; margin-bottom: 10px;">
                    <table>
                      <thead>
                        <tr>
                            <th scope="col">Use</th>
                            <th scope="col">Name</th>
                            <th scope="col">Units</th>
                            <th scope="col">Index</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let el of model.table; let i = index">
                            <td>
                                <input id="chk_{{i}}" name="chk_{{i}}" type="checkbox" [(ngModel)]="el.checked"/>
                            </td>
                            <td>{{el.name}}</td>
                            <td>{{el.index}}</td>
                            <td>{{el.units}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="dropdown-fields">
                    <div>
                      <label for="">Field Separator</label>
                      <select
                          name="fieldSeparator"
                          [(ngModel)]="model.fieldSeparator"
                        >
                          <option value=".">Dot (.)</option>
                          <option value=",">Comma (,)</option>
                          <option value=";">Semicolon (;)</option>
                          <option value="\t">Tab</option>
                          <option value=" ">Space</option>
                        </select>
                    </div>
                  </div>
                  <div class="dropdown-fields">
                    <div>
                      <label for="">Decimal Separator</label>
                      <select
                          name="decimalSeparator"
                          [(ngModel)]="model.decimalSeparator"
                        >
                          <option value=".">Dot (.)</option>
                          <option value=",">Comma (,)</option>
                          <option value=";">Semicolon (;)</option>
                        </select>
                    </div>
                  </div>
              </div>
              <div class="fields__block__section">
                <div class="title">
                  <h4>Processing Tool Data Export Tool</h4>
                  <span> </span>
                </div>
                <div class="input-fields">
                  <div>
                    <label for="">File Name</label>
                    <input
                    style="padding-left: 0px;"
                      maxlength="300"
                      type="text"
                      name="filename"
                      id="filename"
                      [(ngModel)]="model.fileName"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__btn">
              <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="startExport()" [disabled]="!ngForm.form.valid">
                Ok
              </button>
              <button class="gray" (click)="cancelExport()">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
